module.exports = __webpack_public_path__ + "img/icon-server.99d49afb.png";